export enum EFieldType {
  string = 'java.lang.String',
  integer = 'java.lang.Integer',
  long = 'java.lang.Long',
  boolean = 'java.lang.Boolean',
  date = 'java.util.Date',
  decimal= 'java.math.BigDecimal',
  short= 'java.lang.Short'
}
